import { get } from "lodash";
import { FileItem } from "../polymer/Document.model";

export class ApplicationStep4 {
  file_items: FileItem[];
  excepted_documents: string[];

  constructor(initial?: any) {
    this.file_items = get(initial, "file_items", []);
    this.excepted_documents = get(initial, "excepted_documents", []);
  }
}
